"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SparklesIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_2722_1828)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.589 6.993l-1.13 3.896-1.13-3.896L.514 5.84 4.33 4.685 5.459.79l1.13 3.895 3.814 1.154L6.59 6.993zm5.682 2.597l2.826-1.587-1.554 2.886 1.554 2.885-2.826-1.587-2.825 1.587L11 10.889 9.446 8.003l2.825 1.587zm-5.033 1.582l-1.2 2.164 1.2 2.164-2.119-1.226L3 15.5l1.2-2.164L3 11.172l2.119 1.226 2.119-1.226z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_2722_1828"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h16v16H0z"
  })))))
});
SparklesIcon.displayName = 'SparklesIcon';
var _default = exports.default = SparklesIcon;